"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const d3 = __importStar(require("d3"));
const react_2 = require("react");
const ChartContext_1 = require("../context/ChartContext");
const useSpectrum_1 = __importDefault(require("../hooks/useSpectrum"));
const scale_1 = require("./utilities/scale");
const axisStyles = (0, react_1.css) `
  user-select: none;

  path,
  line {
    fill: none;
    stroke: black;
    stroke-width: 1;
    shape-rendering: crispedges;
    user-select: none;
  }
`;
const defaultMargin = { right: 100, top: 0, left: 0, bottom: 0 };
function XAxis(props) {
    const { show = true, margin: marginProps = defaultMargin } = props;
    const { height, width, margin } = (0, ChartContext_1.useChartData)();
    const spectrum = (0, useSpectrum_1.default)();
    const scaleX = (0, scale_1.useScale2DX)();
    const refAxis = (0, react_2.useRef)(null);
    (0, react_2.useEffect)(() => {
        if (!show)
            return;
        const xAxis = d3.axisBottom(scaleX).ticks(8).tickFormat(d3.format('0'));
        // @ts-expect-error actually well typed
        d3.select(refAxis.current).call(xAxis);
    }, [height, margin, scaleX, show, spectrum, width]);
    if (!width || !height) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: show && ((0, jsx_runtime_1.jsx)("g", { className: "x", css: axisStyles, transform: `translate(0,${height - (margin.bottom + marginProps.bottom)})`, ref: refAxis, children: (0, jsx_runtime_1.jsx)("text", { fill: "#000", x: width - 60, y: "20", dy: "0.71em", textAnchor: "end", children: spectrum?.info?.isFid ? 'Time [sec]' : 'δ [ppm]' }) })) }));
}
exports.default = (0, react_2.memo)(XAxis);
